// extracted by mini-css-extract-plugin
module.exports = {"NewsPageCards":"AdDetails_NewsPageCards__3X0Ej"};